module.exports = __webpack_public_path__ + "img/gsndc2765_1.b6f33cb4.svg";